export default __webpack_public_path__ + "static/media/select_file.db5588a1.svg";